<template>
  <div class="request">
    <div class="title-box"><span class="title">REQUEST EVENT</span></div>
    <div class="lists" v-if="reservations.length">
      <request-box
        v-for="(item, index) in reservations"
        :key="index"
        :data="item"
        v-on:model="getRequestReservationForPhotographer"
      ></request-box>
    </div>
    <div class="no-data" v-else>
      <span>There is no request</span>
    </div>
  </div>
</template>
<script>
import RequestBox from '../common/RequestBox'
import { mapGetters } from 'vuex'
import { getRequestReservationsForPhotographer } from '../../api/reservation'

export default {
  components: { RequestBox },
  name: 'request-page',
  data() {
    return {
      reservations: []
    }
  },
  created() {
    this.getRequestReservationForPhotographer()
  },
  methods: {
    getRequestReservationForPhotographer() {
      this.reservations = []
      getRequestReservationsForPhotographer(
        this.$store.getters.userInfo.uid
      ).then(res => {
        this.reservations.push(...res)
        console.log('photographer request: ', res)
      })
    }
  },
  computed: {
    ...mapGetters(['photographerRequest'])
  }
}
</script>
<style lang="scss" scoped>
.request {
  width: 100%;
  height: 100%;
  /*border: 1px dotted red;*/
  .title-box {
    width: 1080px;
    height: 60px;
    background-color: #ffffff;
    border-left: solid 1px #e7e7e7;
    border-top: solid 1px #e7e7e7;
    border-right: solid 1px #e7e7e7;
    text-align: center;
    .title {
      line-height: 60px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
      text-align: center;
      color: #ab08b6;
    }
  }

  .lists {
    margin: 30px 0 0 0;
    .request-box {
      margin-bottom: 10px;
    }
  }

  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: inherit;
    background-color: #f5f5f5;
    margin: 30px 0 0 0;
  }
}
</style>
